import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const User = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22M17.0002 7C17.0002 9.76142 14.7616 12 12.0002 12C9.23873 12 7.00015 9.76142 7.00015 7C7.00015 4.23858 9.23873 2 12.0002 2C14.7616 2 17.0002 4.23858 17.0002 7Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
